// extracted by mini-css-extract-plugin
export var adv = "advance-module--adv--b4d33";
export var container = "advance-module--container--1f376";
export var partnersTtl = "advance-module--partners-ttl--bd677";